import { tv } from '@/common/theme/tv.config';

export const styles = {
  bullet: tv({
    base: 'rounded-full bg-accentSecondary40 opacity-100',
    variants: {
      size: {
        sm: 'h-[1.2rem] w-[1.2rem]',
        md: 'h-[2.4rem] w-[2.4rem]',
        lg: 'h-[3.6rem] w-[3.6rem]',
      },
      n: {
        0: 'animate-[scale_1600ms_linear_infinite]',
        1: 'animate-[scale_1600ms_linear_infinite_200ms]',
        2: 'animate-[scale_1600ms_linear_infinite_400ms]',
        3: 'animate-[scale_1600ms_linear_infinite_600ms]',
        4: 'animate-[scale_1600ms_linear_infinite_800ms]',
      },
    },
    defaultVariants: {
      size: 'md',
    },
  }),
};
